import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { useScreenInit } from '../useScreenInit';
export function Book() {
  useScreenInit();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-[#050505] selection:bg-[#992f74] selection:text-white font-montserrat flex flex-col" data-id="element-294">
      <Header data-id="element-295" />

      <main className="flex-grow pt-24 pb-16 relative overflow-hidden" data-id="element-296">
        {/* Subtle Background Glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#992f74]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-297"></div>

        <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-298">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-center mb-12" data-id="element-299">
            <h1 className="text-5xl md:text-7xl font-montserrat font-black italic text-[#992f74] mb-6" data-id="element-300">
              Book Your Experience
            </h1>
            <p className="text-white/70 text-lg md:text-xl max-w-2xl mx-auto font-light" data-id="element-301">
              Ready to elevate your next event? Fill out the form below and our
              team will get back to you to start crafting your bespoke beverage
              experience.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-[#111] border border-white/10 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-302">
            <form className="space-y-8" data-id="element-303">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-304">
                {/* Name */}
                <div className="space-y-2" data-id="element-305">
                  <label htmlFor="name" className="text-white/80 text-sm font-bold tracking-widest uppercase" data-id="element-306">
                    Full Name
                  </label>
                  <input type="text" id="name" className="w-full bg-transparent border-b border-white/20 pb-2 text-white focus:outline-none focus:border-[#992f74] transition-colors placeholder:text-white/30" placeholder="Jane Doe" data-id="element-307" />
                </div>

                {/* Email */}
                <div className="space-y-2" data-id="element-308">
                  <label htmlFor="email" className="text-white/80 text-sm font-bold tracking-widest uppercase" data-id="element-309">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full bg-transparent border-b border-white/20 pb-2 text-white focus:outline-none focus:border-[#992f74] transition-colors placeholder:text-white/30" placeholder="jane@example.com" data-id="element-310" />
                </div>

                {/* Phone */}
                <div className="space-y-2" data-id="element-311">
                  <label htmlFor="phone" className="text-white/80 text-sm font-bold tracking-widest uppercase" data-id="element-312">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" className="w-full bg-transparent border-b border-white/20 pb-2 text-white focus:outline-none focus:border-[#992f74] transition-colors placeholder:text-white/30" placeholder="(555) 123-4567" data-id="element-313" />
                </div>

                {/* Event Date */}
                <div className="space-y-2" data-id="element-314">
                  <label htmlFor="date" className="text-white/80 text-sm font-bold tracking-widest uppercase" data-id="element-315">
                    Event Date
                  </label>
                  <input type="date" id="date" className="w-full bg-transparent border-b border-white/20 pb-2 text-white focus:outline-none focus:border-[#992f74] transition-colors placeholder:text-white/30 [color-scheme:dark]" data-id="element-316" />
                </div>

                {/* Event Type */}
                <div className="space-y-2" data-id="element-317">
                  <label htmlFor="type" className="text-white/80 text-sm font-bold tracking-widest uppercase" data-id="element-318">
                    Event Type
                  </label>
                  <select id="type" className="w-full bg-transparent border-b border-white/20 pb-2 text-white focus:outline-none focus:border-[#992f74] transition-colors [&>option]:bg-[#111]" data-id="element-319">
                    <option value="" disabled selected className="text-white/30" data-id="element-320">
                      Select an event type
                    </option>
                    <option value="wedding" data-id="element-321">Wedding</option>
                    <option value="corporate" data-id="element-322">Corporate Event</option>
                    <option value="milestone" data-id="element-323">Milestone Celebration</option>
                    <option value="other" data-id="element-324">Other</option>
                  </select>
                </div>

                {/* Guest Count */}
                <div className="space-y-2" data-id="element-325">
                  <label htmlFor="guests" className="text-white/80 text-sm font-bold tracking-widest uppercase" data-id="element-326">
                    Estimated Guest Count
                  </label>
                  <input type="number" id="guests" className="w-full bg-transparent border-b border-white/20 pb-2 text-white focus:outline-none focus:border-[#992f74] transition-colors placeholder:text-white/30" placeholder="100" data-id="element-327" />
                </div>
              </div>

              {/* Message */}
              <div className="space-y-2" data-id="element-328">
                <label htmlFor="message" className="text-white/80 text-sm font-bold tracking-widest uppercase" data-id="element-329">
                  Tell us about your event
                </label>
                <textarea id="message" rows={4} className="w-full bg-transparent border-b border-white/20 pb-2 text-white focus:outline-none focus:border-[#992f74] transition-colors placeholder:text-white/30 resize-none" placeholder="Share any specific themes, cocktail requests, or details we should know..." data-id="element-330"></textarea>
              </div>

              {/* Submit Button */}
              <div className="pt-8 flex justify-center" data-id="element-331">
                <button type="button" className="relative overflow-hidden group bg-[#992f74] text-white px-16 py-4 text-sm font-bold tracking-[0.2em] uppercase transition-all duration-300 hover:text-white" data-id="element-332">
                  <span className="relative z-10" data-id="element-333">Submit Inquiry</span>
                  <div className="absolute inset-0 h-full w-full bg-black transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" data-id="element-334"></div>
                </button>
              </div>
            </form>
          </motion.div>
        </div>

        {/* FAQ Section */}
        <div className="max-w-4xl mx-auto px-6 mt-20 relative z-10" data-id="element-335">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-336">
            <h2 className="text-4xl md:text-5xl font-montserrat font-black italic text-white mb-4" data-id="element-337">
              Frequently Asked Questions
            </h2>
            <div className="w-16 h-[2px] bg-[#992f74] mx-auto" data-id="element-338"></div>
          </motion.div>

          <div className="space-y-8" data-id="element-339">
            {[{
            q: 'Can you work with outdoor or unconventional event spaces?',
            a: 'Definitely. Whether it’s an outdoor setup, backyard party, rooftop, or rented venue, we adapt our setup to fit the space safely and efficiently.'
          }, {
            q: 'How far in advance should I book your services for an event?',
            a: 'Yes! We can tailor cocktails, mocktails, and gourmet bites to match your theme, color palette, or celebration style.'
          }, {
            q: 'Do you provide setup and cleanup?',
            a: 'Absolutely, Our team handles full setup and cleanup so you can focus on enjoying your event without any stress.'
          }, {
            q: 'What is included in your premium service package?',
            a: 'Our premium package includes on-site mixologists, beautifully crafted drinks, gourmet bites service, full setup, stylish presentation, and elevated guest interaction.'
          }, {
            q: 'Do you provide on-site service for events?',
            a: 'Yes, we offer premium on-site service, including live mixology, gourmet bite catering, and full event support.'
          }, {
            q: 'What areas do you deliver to?',
            a: 'We deliver to most surrounding areas. Just share your location, and we’ll confirm availability.'
          }].map((faq, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-[#111] border border-white/5 rounded-xl p-6 md:p-8 hover:border-[#992f74]/30 transition-colors" data-id="element-340">
                <h3 className="text-[#992f74] font-montserrat text-xl md:text-2xl italic mb-3" data-id="element-341">
                  {faq.q}
                </h3>
                <p className="text-white/70 font-light leading-relaxed" data-id="element-342">
                  {faq.a}
                </p>
              </motion.div>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-343" />
    </motion.div>;
}